/**
 * Emitting a CLOSED state requires that you *synchronously* run clean-up code, especially if it involves removal of keyboard traps or focus related logic,
 * as once a CLOSED state has been emitted
 */
export enum DialogState {
    CLOSING = "Closing",
    CLOSED = "Closed",
    OPEN = "Open"
}
